<template>
  <g id="library_background_characters">

    <!-- move all characters down -->
    <g transform="translate(0, 32)">

      <!-- first -->
      <girl-5 :data="girl5Data"></girl-5>
      <boy-5 :data="boy5Data"></boy-5>
      <girl-3 :data="girl3Data"></girl-3>

      <!-- second -->
      <girl-4 :data="girl4Data"></girl-4>
      <boy-2 :data="boy2Data"></boy-2>
      <boy-1 :data="boy1Data"></boy-1>

      <!-- third -->
      <boy-4 :data="boy4Data"></boy-4>
      <girl-1 :data="girl1Data"></girl-1>
      <boy-3 :data="boy3Data"></boy-3>
    </g>

  </g>
</template>


<script>
  import anime from 'animejs'

  import boy5 from './background/boy5'
  import girl5 from './background/girl5'
  import boy1 from './background/boy1'
  import boy2 from './background/boy2'
  import girl4 from './background/girl4'
  import girl1 from './background/girl1'
  import boy4 from './background/boy4'
  import boy3 from './background/boy3'
  import girl3 from './background/girl3'

  import {
    characterSpeech
  } from '@/assets/js/utils/characterSpeech'

  const defaults = {
    blinking: false,
    speaking: false,
    headRotate: false,
    armRaised: true
  }

  export default {
    data() {
      return {
        girl5Data: { ...defaults
        },
        boy5Data: { ...defaults
        },
        girl4Data: { ...defaults
        },
        boy2Data: { ...defaults
        },
        boy1Data: { ...defaults
        },
        boy4Data: { ...defaults
        },
        girl1Data: { ...defaults
        },
        boy3Data: { ...defaults
        },
        girl3Data: { ...defaults
        }
      }
    },
    components: {
      'boy-5': boy5,
      'girl-5': girl5,
      'boy-1': boy1,
      'boy-2': boy2,
      'girl-4': girl4,
      'girl-1': girl1,
      'boy-4': boy4,
      'boy-3': boy3,
      'girl-3': girl3
    },
    mounted() {

      // create a bunch of animation loops.

      // random number generator
      const generateRandom = (min, max) => {
        return Math.random() * (max - min) + min;
      }

      // all background characters
      // callbacks used for arm animations
      const characters = [{
          data: this.girl5Data,
          callback: () => {
            // removed callbacks for now because firefox compatability issues
            // anime({
            //   targets: "#girl5_left_arm_hand",
            //   rotate: [{
            //       value: '90deg',
            //       duration: 400,
            //     },
            //     {
            //       value: '0deg',
            //       duration: 400,
            //       delay: generateRandom(4000, 5600) // intentionally set as less than generateRandom() for createSpeakingAnimation
            //     }
            //   ],
            //   easing: 'linear'
            // })
          }
        },
        {
          data: this.boy5Data,
          callback: () => {
            // anime({
            //   targets: "#boy5_left_arm_hand",
            //   rotate: [{
            //       value: '-120deg',
            //       duration: 400,
            //     },
            //     {
            //       value: '0deg',
            //       duration: 400,
            //       delay: generateRandom(4000, 5600)
            //     }
            //   ],
            //   easing: 'linear'
            // })
          }
        },
        {
          data: this.girl4Data
        },
        {
          data: this.boy2Data
        },
        {
          data: this.boy1Data
        },
        {
          data: this.boy4Data
        },
        {
          data: this.girl1Data,
          callback: () => {
            // anime({
            //   targets: "#girl1",
            //   scaleX: [{
            //       value: -1,
            //       duration: 1
            //     },
            //     {
            //       value: 1,
            //       duration: 1,
            //       delay: generateRandom(4000, 5600)
            //     }
            //   ],
            //   easing: 'linear'
            // })
          }
        },
        {
          data: this.boy3Data
        },
        {
          data: this.girl3Data
        }
      ]


      // blinking animation
      const createBlinkAnimation = (data) => {
        setInterval(() => {
          data.blinking = true
          setTimeout(() => {
            data.blinking = false
          }, 300)
        }, generateRandom(6000, 8000)) // make random number
      }

      // speaking animation
      const createSpeakingAnimation = (data, callback) => {
        callback = callback || function () {}
        setInterval(() => {
          characterSpeech(data, generateRandom(2, 5))
          if (generateRandom(-1, 1) > 0) { // fire callback (arm raise) half of the time
            callback()
          }
        }, generateRandom(6000, 8000)) // generateRandom(6000, 8000)
      }

      // head rotate animation
      const createHeadRotateAnimation = (data) => {
        setInterval(() => {
          data.headRotate = true
          setTimeout(() => {
            data.headRotate = false
          }, generateRandom(4000, 5600))
        }, generateRandom(10000, 12000))
      }

      // init animations
      for (let i = 0; i < characters.length; i++) {
        setTimeout(() => {
          createBlinkAnimation(characters[i].data)
          createSpeakingAnimation(characters[i].data, characters[i].callback)
          createHeadRotateAnimation(characters[i].data)
        }, generateRandom(0, 2000))
      }
    }
  }

</script>



// WEBPACK FOOTER //
// backgroundCharacters.vue?4e6bf275